export const clock = "object" == typeof performance && performance.now ? performance : Date;
//# sourceMappingURL=util.js.map
